import React, {MutableRefObject, useEffect, useRef, useState,} from 'react';
import Layout from './layout';
import StatusView from './status-view';
import EntityForm from './entity-form';
import DataGraphDefModel from '../models/data-graph-def';
import EntityDataGraphView from './entity-datagraph-view';
import EntityFormModel from '../models/entity-form';
import {EntityTypeEnum} from '../enums/EntityTypeEnum';
import {StatusMessageTypeEnum} from "../enums/StatusMessageTypeEnum";
import IStatusMessage from "../models/status-message";

function DataGraph(): React.ReactElement {
    const emptyStatus: IStatusMessage = {message: "", type: StatusMessageTypeEnum.none}
    const graphDefInit: DataGraphDefModel = {
        entity: {
            id: '',
            target: '',
            type: EntityTypeEnum.main,
            verb: '',
            connectingVerb: '',
            searchRef: '',
        },
        joins: [],
        brothers: [],
        autoLoadTriplets: false,
    };
    const [statusMessage, setStatusMessage] = useState(emptyStatus);
    const [graphDefinition, setGraphDef] = useState(graphDefInit);
    const [loadTriplets, setLoadTriplets] = useState(false);
    const graphViewRef = useRef() as MutableRefObject<any>;

    const handleOnRemove = (entity: EntityFormModel) => {
        switch (entity.type) {
            case EntityTypeEnum.joined:
                setGraphDef((prevState) => ({
                    ...prevState,
                    joins: prevState.joins.filter((item) => (item.id !== entity.id)),
                }));
                break;
            case EntityTypeEnum.brother:
                setGraphDef((prevState) => ({
                    ...prevState,
                    brothers: prevState.brothers.filter((item) => (item.id !== entity.id)),
                }));
                break;
            default:
                break;
        }
    };

    const onStatusMessage = (message: string, type: StatusMessageTypeEnum) => {
        setStatusMessage({message, type});
    };

    useEffect(() => {
    }, [graphDefinition]);

    const addJoinedEntity = () => {
        setGraphDef((prevState) => ({
            ...prevState,
            joins:
                [...prevState.joins, {
                    id: String(prevState.joins.length + 1),
                    target: '',
                    type: EntityTypeEnum.joined,
                    verb: '',
                    connectingVerb: '',
                    searchRef: '',
                }],
        }));
    };

    const addBrotherVerb = () => {
        setGraphDef((prevState) => ({
            ...prevState,
            brothers:
                [...prevState.brothers,
                    {
                        id: String(prevState.brothers.length + 1),
                        target: '',
                        type: EntityTypeEnum.brother,
                        verb: '',
                        connectingVerb: '',
                        searchRef: '',
                    },
                ],
        }));
    };

    const handleDataGraphChange = (entity: EntityFormModel) => {
        switch (entity.type) {
            case EntityTypeEnum.main:
                setGraphDef((prevState) => ({
                    ...prevState,
                    entity,
                }));
                break;
            case EntityTypeEnum.joined:
                setGraphDef((prevState) => ({
                    ...prevState,
                    joins: prevState.joins?.map((item) => (item.id === entity.id
                        ? {
                            ...item,
                            id: entity.id,
                            type: entity.type,
                            verb: entity.verb,
                            connectingVerb: entity.connectingVerb,
                            target: entity.target,
                            searchRef: entity.searchRef,
                        } : item)),
                }));
                break;
            case EntityTypeEnum.brother:
                setGraphDef((prevState) => ({
                    ...prevState,
                    brothers: prevState.brothers?.map((item) => (item.id === entity.id
                        ? {
                            ...item,
                            id: entity.id,
                            type: entity.type,
                            verb: entity.verb,
                            connectingVerb: entity.connectingVerb,
                            target: entity.target,
                            searchRef: entity.searchRef,
                        } : item)),
                }));
                break;
            default:
                break;
        }
    };

    return (
        <Layout className="page datagraph ">
            <StatusView status={statusMessage}/>
            <div className="row flex-nowrap">
                <div className="col-auto" style={{backgroundColor: '#ededed'}}>
                    <div id="sidebar" className="collapse-horizontal border-end collapse pt-3"
                         style={{maxWidth: '350px'}}>
                        <div id="sidebar-nav" className="border-0 rounded-0 text-sm-start min-vh-100"
                             style={{backgroundColor: '#ededed', minWidth: '350px'}}>
                            <div className="ps-1 pe-1" style={{minHeight: '600px'}}>
                                <h5 className="text-uppercase pt-1 ps-1 pt-2">Data Graph Definition</h5>
                                <EntityForm
                                    key={0}
                                    setStatusMessage={onStatusMessage}
                                    removeEntity={() => {
                                    }}
                                    onChange={handleDataGraphChange}
                                    entity={{
                                        id: '',
                                        type: EntityTypeEnum.main,
                                        verb: '',
                                        connectingVerb: '',
                                        target: '',
                                        searchRef: '',
                                    }}
                                />
                                <div className="mb-5 ">
                                    <div className="mb-2 ">
                                        <div className="row">
                                            <div className="col-12 mb-1">
                                                <button
                                                    className="btn btn-dark d-inline-block mt-2 mb-2 d-block w-100"
                                                    type="submit"
                                                    onClick={() => graphViewRef.current.refresh()}
                                                >
                                                    Load
                                                </button>
                                                <label htmlFor="loadTriplets" className="form-label w-100">
                                                    <input
                                                        id="loadTriplets"
                                                        type="checkbox"
                                                        checked={loadTriplets}
                                                        className=""
                                                        onChange={(e) => {
                                                            setLoadTriplets(e.target.checked);
                                                            setGraphDef((prevState) => ({
                                                                ...prevState, autoLoadTriplets: e.target.checked,
                                                            }));
                                                        }}
                                                    />
                                                    <span className="ps-2">Auto load triplets</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="row" style={{display: loadTriplets ? 'none' : ''}}>
                                            <div className="col-md-6 mb-1">
                                                <button type="submit" className="btn btn-light d-inline-block w-100"
                                                        onClick={() => {
                                                            addJoinedEntity();
                                                        }}>Add Joined Entity
                                                </button>
                                            </div>
                                            <div className="col-md-6 mb-1">
                                                <button type="submit" className="btn btn-light d-inline-block w-100"
                                                        onClick={() => {
                                                            addBrotherVerb();
                                                        }}>Add Brother Verb
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{display: loadTriplets ? 'none' : ''}}>

                                        <h6 style={{backgroundColor: '#f0f8ff', padding: '1rem .5rem'}}
                                            className="mb-0 mt-3">Joined</h6>
                                        {
                                            graphDefinition.joins.map((item) => (
                                                <EntityForm
                                                    key={item.id}
                                                    setStatusMessage={onStatusMessage}
                                                    removeEntity={handleOnRemove}
                                                    onChange={handleDataGraphChange}
                                                    entity={{
                                                        id: item.id,
                                                        type: EntityTypeEnum.joined,
                                                        verb: '',
                                                        connectingVerb: '',
                                                        target: '',
                                                        searchRef: '',
                                                    }}
                                                />
                                            ))
                                        }
                                        <h6 style={{backgroundColor: '#f0f8ff', padding: '1rem .5rem'}}
                                            className="mb-0 mt-3">Brothers</h6>
                                        {
                                            graphDefinition.brothers.map((item) => (
                                                <EntityForm
                                                    key={item.id}
                                                    setStatusMessage={onStatusMessage}
                                                    removeEntity={handleOnRemove}
                                                    onChange={handleDataGraphChange}
                                                    entity={{
                                                        id: item.id,
                                                        type: EntityTypeEnum.brother,
                                                        verb: '',
                                                        connectingVerb: '',
                                                        target: '',
                                                        searchRef: '',
                                                    }}
                                                />
                                            ))
                                        }
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col  pt-2">
                    <div className="container-fluid ps-0">
                        <div className="clearfix text-center">
              <span
                  data-bs-target="#sidebar"
                  data-bs-toggle="collapse"
                  aria-expanded="false"
                  className="link-hover collapsed float-start"
              >
                <i className="bi bi-list bi-lg py-2 p-1">Filter</i>
              </span>
                            <h5 className="text-uppercase pt-1 pt-1 ">Data Graph View</h5>
                        </div>
                    </div>
                    <div className="mb-5">
                        <div className="">
                            <EntityDataGraphView ref={graphViewRef} id="" setStatusMessage={onStatusMessage}
                                                 graphDefinition={graphDefinition}/>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default DataGraph;
